import "./Hero.css";

import heroImage from "../img/hero.png";

function Hero() {

    return (

        <section
            className="hero"
            style={{
                backgroundImage: `url(${heroImage})`
            }}
        >

            <div className="hero-overlay"></div>

            <div className="hero-content">

                <span className="hero-tag">
                    CUSTOM SIGNAGE SOLUTIONS
                </span>

                <h1>

                    Custom Signs Built to
                    <br />
                    Elevate Your Business

                </h1>

                <p>

                    From design and fabrication to professional installation,
                    3 Point Signs delivers high-quality signage solutions
                    tailored to your brand and built to last.

                </p>

                <div className="hero-buttons">

                    <a
                        href="#contact"
                        className="hero-btn-primary"
                        style={{ color: "white", textDecoration: "none" }}
                    >

                        Request a Quote

                    </a>

                    <a
                        href="#projects"
                        className="hero-btn-secondary"
                        
                    >

                        View Projects

                    </a>

                </div>

            </div>

        </section>

    );

}
export default Hero;